import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CustomMetaService } from '@core/services/meta-service/meta.service';
import { environment } from '@environment';
import { trackEventWithAtInternet } from '@wizbii/tracking';

@Component({
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewComponent implements OnInit, OnDestroy {
  trackEvent = trackEventWithAtInternet;

  illustrationSrc = `url(${environment.wizbiiImages}/training-obligation/training-obligation-illustration.jpg)`;

  constructor(private readonly metaService: CustomMetaService) {}

  ngOnInit(): void {
    this.metaService.updateForSeo({ title: 'Je me fais accompagner pour construire mon avenir' });
  }

  onTrackerClicked(action: string): void {
    this.trackEvent({
      category: 'Obligation Formation',
      action: `Click ${action}`,
      type: 'navigation',
    });
  }

  ngOnDestroy(): void {
    this.metaService.restoreForSeo();
  }
}
